import { FC } from 'react';
import { Typography } from '@mui/material';
import { pxToRem } from '@/theme/typography';

interface GenreTitleProps {
  title?: string;
  bgColor?: string;
  color?: string;
}

export const GenreTitle: FC<GenreTitleProps> = genreTitleProps => {
  return (
    <Typography
      component='span'
      sx={{
        fontSize: pxToRem(18),
        color: genreTitleProps.color,
        backgroundColor: genreTitleProps.bgColor,
        borderRadius: '37px',
        px: pxToRem(12),
        py: pxToRem(6),
        mr: pxToRem(8),
        textAlign: 'center',
      }}
    >
      {genreTitleProps.title}
    </Typography>
  );
};

export default GenreTitle;
